/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NormalErrorGoodsProcessVo } from './NormalErrorGoodsProcessVo';
import {
    NormalErrorGoodsProcessVoFromJSON,
    NormalErrorGoodsProcessVoFromJSONTyped,
    NormalErrorGoodsProcessVoToJSON,
    NormalErrorGoodsProcessVoToJSONTyped,
} from './NormalErrorGoodsProcessVo';

/**
 * 
 * @export
 * @interface ProcessNormalErrorGoodsReqVo
 */
export interface ProcessNormalErrorGoodsReqVo {
    /**
     * 商品检查单处理VO集合
     * @type {Array<NormalErrorGoodsProcessVo>}
     * @memberof ProcessNormalErrorGoodsReqVo
     */
    errorGoodsProcessVOs?: Array<NormalErrorGoodsProcessVo>;
    /**
     * 订单ID
     * @type {number}
     * @memberof ProcessNormalErrorGoodsReqVo
     */
    orderId?: number;
}

/**
 * Check if a given object implements the ProcessNormalErrorGoodsReqVo interface.
 */
export function instanceOfProcessNormalErrorGoodsReqVo(value: object): value is ProcessNormalErrorGoodsReqVo {
    return true;
}

export function ProcessNormalErrorGoodsReqVoFromJSON(json: any): ProcessNormalErrorGoodsReqVo {
    return ProcessNormalErrorGoodsReqVoFromJSONTyped(json, false);
}

export function ProcessNormalErrorGoodsReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessNormalErrorGoodsReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'errorGoodsProcessVOs': json['errorGoodsProcessVOs'] == null ? undefined : ((json['errorGoodsProcessVOs'] as Array<any>).map(NormalErrorGoodsProcessVoFromJSON)),
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
    };
}

export function ProcessNormalErrorGoodsReqVoToJSON(json: any): ProcessNormalErrorGoodsReqVo {
    return ProcessNormalErrorGoodsReqVoToJSONTyped(json, false);
}

export function ProcessNormalErrorGoodsReqVoToJSONTyped(value?: ProcessNormalErrorGoodsReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'errorGoodsProcessVOs': value['errorGoodsProcessVOs'] == null ? undefined : ((value['errorGoodsProcessVOs'] as Array<any>).map(NormalErrorGoodsProcessVoToJSON)),
        'orderId': value['orderId'],
    };
}

